export const MILLISECOND = 1;
export const SECOND = 1000 * MILLISECOND;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const IDLE_TIMEOUT = 5 * MINUTE; // 5 min
export const GLOBAL_UPDATE_RATE = 30 * SECOND; // 1 min
export const TOASTS_TIMEOUT = 3 * SECOND; // 3s
export const KB = 1024;
export const MB = 1024 * KB;
export const TOKEN_INFO_MAX_VISIBLE_VALUE = 1000000;
export const MAX_FIAT_AMOUNT = 100000;
export const NATIVE_OPTIONS = [10000, 50000];
export const SUPPORT_CHAT_IMAGE_TYPES = ['image/jpeg', 'image/png'];
export const SUPPORT_CHAT_IMAGES_MAX_LENGTH = 10;
export const SUPPORT_CHAT_FILES_MAX_LENGTH = 1;
export const SUPPORT_CHAT_FILE_TYPES = [
  'application/pdf' // .pdf
  // 'application/msword', // .doc
  // 'application/vnd.ms-word', // .doc
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  // 'text/csv', // .csv
  // 'application/json', // .json
  // 'application/vnd.oasis.opendocument.spreadsheet', // .ods
  // 'application/vnd.oasis.opendocument.text', // .odt
  // 'text/plain', // .txt
  // 'application/rtf', // .rtf
  // 'text/rtf' // .rtf
];
export const SUPPORT_CHAT_FILE_SIZE = 10 * MB;
export const SUPPORT_CHAT_INTERVAL_TO_DISPLAY_TIME_IN_SECONDS = 5 * 60; // 5min

export const HEARTBEAT_CHECK_INTERVAL = 5 * SECOND;
export const HEARTBEAT_SEND_THROTTLE_TIMEOUT = MINUTE;
export const FORM_SET_AMOUNT_DEBOUNCE = 500 * MILLISECOND;
export const CHAT_SEEN_MESSAGES_DEBOUNCE = SECOND;

export const MAX_TOKEN_VISIBLE_DECIMALS = 6;
export const TOKEN_SEARCH_TERM_DEBOUNCE = 250 * MILLISECOND;

export const MIN_SEND_AMOUNT_EUR = '0.01';
